import AddressVerificationProvider from '../addressVerification/AddressVerificationProvider';
import FormHandler from '../forms/FormHandler';
import StateFilteredAddress from '../forms/address/StateFilteredAddress';

/** @typedef {import('../forms/address/types').Address} Address */

class AccountCreateUpdateFormHandler {
  /**
   * @param {HTMLFormElement} $form
   * @param {boolean} isAddressVerificationEnabled
   * @param {Object} stateFilterConfig
   * @param {boolean} isAddressSectionDisplayed
   * @param {Address} primaryAddress
   * @param {boolean} isRecaptchaEnabled
   */
  constructor($form, isAddressVerificationEnabled, stateFilterConfig, isAddressSectionDisplayed, primaryAddress = null, isRecaptchaEnabled = false) {
    this.$form = $form;
    this.isRecaptchaEnabled = isRecaptchaEnabled;
    this.isAddressSectionDisplayed = isAddressSectionDisplayed;

    this.form = new FormHandler($form, {
      onValidationSuccess: this.onSubmit,
    });

    if (this.isAddressSectionDisplayed) {
      this.addressForm = new StateFilteredAddress(this.form, {
        countries: stateFilterConfig.countries,
        states: stateFilterConfig.states,
        fields: {
          Street1: 'Address.Address1',
          Street2: 'Address.Address2',
          CountryId: 'Address.CountryId',
          StateId: 'Address.StateId',
          PostalCode: 'Address.PostalCode',
          City: 'Address.City',
        },
      });

      this.avsProvider = new AddressVerificationProvider(this.addressForm, primaryAddress, isAddressVerificationEnabled);
    }
  }

  onSubmit = async ({ stopSubmitting }) => {
    const { $form, avsProvider, addressForm } = this;

    if (this.testShouldVerifyAddress()) {
      const response = await avsProvider.verifyAddress();

      if (response) {
        if (response.wasCancelled) {
          response.modal.close();

          stopSubmitting();

          return;
        }

        addressForm.updateAddress(response.confirmedAddress);
      }
    }

    $form.submit();
  };

  testShouldVerifyAddress() {
    const { avsProvider, isRecaptchaEnabled, isAddressSectionDisplayed } = this;

    if (!isAddressSectionDisplayed) {
      return false;
    }

    if (isRecaptchaEnabled) {
      if (!window.grecaptcha.getResponse()) {
        return false;
      }
    }

    return avsProvider.testCanVerifyAddress();
  }
}

export default AccountCreateUpdateFormHandler;
